import { useQuery } from '@tanstack/react-query';
import { Endpoint } from '@/Config/api/endpoint';
import { SubscriptionApi } from '@/Domain/api/Subscription/Subscription.api';
import { SubscriptionDto } from '@/Domain/api/Subscription/dto/Subscription.dto';

export const useGetSubscription = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const query = useQuery<SubscriptionDto>({
    queryKey: [Endpoint.subscription.get],
    queryFn: () => SubscriptionApi.get(),
    enabled,
  });

  return { ...query };
};
